export const TOUR_LIKES_OPTIONS = {
  laundry: {
    key: "laundry",
    position: 1,
    label: "Laundry"
  },
  sunlight: {
    key: "sunlight",
    position: 2,
    label: "Sunlight"
  },
  "outdoor-space": {
    key: "outdoor-space",
    position: 3,
    label: "Outdoor Space"
  },
  elevator: {
    key: "elevator",
    position: 4,
    label: "Elevator"
  },
  dishwasher: {
    key: "dishwasher",
    position: 5,
    label: "Dishwasher"
  },
  kitchen: {
    key: "kitchen",
    position: 6,
    label: "Kitchen"
  },
  "closet-space": {
    key: "closet-space",
    position: 7,
    label: "Closet Space"
  },
  location: {
    key: "location",
    position: 8,
    label: "Location"
  },
  commute: {
    key: "commute",
    position: 9,
    label: "Commute"
  },
  doorman: {
    key: "doorman",
    position: 10,
    label: "Doorman"
  },
  surroundings: {
    key: "surroundings",
    position: 11,
    label: "Surroundings"
  },
  neighborhood: {
    key: "neighborhood",
    position: 12,
    label: "Neighborhood"
  },
  size: {
    key: "size",
    position: 13,
    label: "Size"
  },
  "pet-friendly": {
    key: "pet-friendly",
    position: 14,
    label: "Pet Friendly"
  },
  layout: {
    key: "layout",
    position: 15,
    label: "Layout"
  },
  ac: {
    key: "ac",
    position: 16,
    label: "AC"
  },
  "price-value": {
    key: "price-value",
    position: 17,
    label: "Price Value"
  },
  bathroom: {
    key: "bathroom",
    position: 18,
    label: "Bathroom"
  },
  gym: {
    key: "gym",
    position: 19,
    label: "Gym"
  },
  view: {
    key: "view",
    position: 20,
    label: "View"
  },
  accessible: {
    key: "accessible",
    position: 21,
    label: "Accessible"
  },
  parking: {
    key: "parking",
    position: 22,
    label: "Parking"
  },
  "bike-friendly": {
    key: "bike-friendly",
    position: 23,
    label: "Bike Friendly"
  },
  floors: {
    key: "floors",
    position: 24,
    label: "Floors"
  }
};
